<template>
  <div class="badge">
    <slot />
  </div>
</template>
<style lang="scss">
.badge {
  @apply px-3 py-1 text-xs font-semibold uppercase text-white max-sm:px-2;
}
</style>
